

















import {Vue, Component, Prop} from 'vue-property-decorator';
import {InputDialogEvents} from '@/events';

export enum InputDialogAction
{
	Rename,
	CreateDirectory
}

@Component({
	name: 'InputDialog'
})
export default class InputDialog extends Vue {
	@Prop()
	private title: string;

	@Prop()
	private initialValue: string;

	private value: string = null;

	@Prop()
	private action: InputDialogAction;

	public mounted()
	{
		const input = this.$refs.input as HTMLInputElement;

		if (input)
		{
			input.focus();
		}
	}

	public confirm()
	{
		this.$emit(InputDialogEvents.inputConfirmed, this.value);
	}

	public cancel()
	{
		this.$emit(InputDialogEvents.inputCanceled);
	}
}
